import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IUserDeletionInfo } from '@account-users/user/models/IDeletedUserInfo';
import { IAccountUser } from '@account-users/account/models/IAccountUser';

@Component({
  selector: 'app-delete-user-modal',
  templateUrl: './delete-user-modal.component.html',
  styleUrls: ['./delete-user-modal.component.scss'],
})
export class DeleteUserModalComponent {
  @Input() user: IAccountUser;
  @Input() accountId: string;
  @Output() deleteUser = new EventEmitter<IUserDeletionInfo>();
  error: Error;

  constructor(public activeModal: NgbActiveModal) {}

  onDeleteUser() {
    this.deleteUser.emit({ user: this.user, accountId: this.accountId });
  }
}
